import { 
    apiRequest,
    PendidikanList,
    RiwayatNikahList,
    RiwayatNikahActive,
    RiwayatNikahInactive
 } from '../../../../../services/adapters/kepegawaian/riwayatnikahService'

class RiwayatNikahRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", RiwayatNikahList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", RiwayatNikahInactive, {
            body: query
        }, true)
    }

    fetchActive = async (query) => {
        return await apiRequest("post", RiwayatNikahActive, {
            body: query
        }, true)
    }

    fetchPendidikan = async (query, cancelToken) => {
        return await apiRequest("get", PendidikanList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

}

export default RiwayatNikahRepository